export const homePageSet = {
	id: '648227972788568780',
	subsystemId: '495638169874579456',
	parentId: '495638169874579457',
	parentName: '平台管理',
	asName: '首页',
	name: '首页',
	code: '首页',
	sort: 10,
	type: '1040010',
	skipType: '1030005',
	skipUrl: '/zeus-system/system-permissions/Home',
	isNew: true,
	icon: 'G0001',
	iconUrl: 'https://tongbang-qa.oss-cn-shanghai.aliyuncs.com/20230423/59490098f4594d979c10751840784f95.png',
	hlightIcon: 'G0001',
	hlightIconUrl: 'https://tongbang-qa.oss-cn-shanghai.aliyuncs.com/20230423/59490098f4594d979c10751840784f95.png',
	wkcardIcon: 'G0001',
	wkcardIconUrl: 'https://tongbang-qa.oss-cn-shanghai.aliyuncs.com/20230423/59490098f4594d979c10751840784f95.png',
	isAuthResource: true,
	roleMenuButtonList: null
};
